<template>
  <div class="newInviteHomePop">
    <div class="newInvitePopCard" @click="gotoEarn()">
      <img src="../../assets/images/invite/PGE_invite_popup.png" alt="" class="bg">
      <img class="close" @click.stop="close" src="../../assets/images/WithdrawalSuccessful/close.png">
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  methods: {
    gotoEarn () {
      this.$emit('handleClose')
      this.$router.push('/Earn')
    },
    close () {
      this.$emit('handleClose')
    }
  }
}
</script>
<style scoped lang="less">
.newInviteHomePop{
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  left: 0;
  display:  flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  .newInvitePopCard{
    width: 85vw;
    height: 100vw;
    background-size: 100% 100%;
    //border: 1px solid red;
    position: relative;
    .bg{
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
    .close{
      position: absolute;
      height: 5.05vw;
      width: 5.05vw;
      top: 104vw;
      left: 40vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NewInviteHomePop/index.vue